import { Box, FormGroup, Button } from '@mui/material';

import React, {} from 'react';

import { Save, Undo } from '@mui/icons-material';
import __t from '../../../lib/traduzioni';
import { FormProvider, useForm } from 'react-hook-form';
import useBSSLogger from '../../../hooks/useBSSLogger';
import { creaTipiColli } from '../../../api/ttipicolli';
import { FormMisure } from '../../account/Preferenze';
import BSSForm from '../../form/BSSForm';
import { BSSDialogWithActions } from '../../form/BSSDialog';
import { DefaultSubmitErrorHandler } from './../Preventivo';
import { useEffect } from 'react';

 
const {logger} = useBSSLogger();


const DialogNuovaMisura = ({objTipoSelezionato, setOpenDialogNuovaMisura, openDialogNuovaMisura, tipiSpedizione, aggiornaPreferenze, drawerTipiColli, setDrawerTipiColli}) => {

    logger.debug("aggiornato il tipo selezionato", objTipoSelezionato);

    const defaultValues = {tipoSpedizione: objTipoSelezionato};

    const methodsMisura = useForm({defaultValues})

    useEffect(() => {
        if(objTipoSelezionato){

            const {id: nuovoId = -1} = objTipoSelezionato
            const sel = methodsMisura?.getValues("tipoSpedizione") ?? null;
            const {id: vecchioId = -1} = sel ?? {};

            if(Number(nuovoId) !== Number(vecchioId)){
                logger.debug("aggiorno il form per la creazione di misure predefinite", objTipoSelezionato)
                methodsMisura.setValue("tipoSpedizione", objTipoSelezionato)
            }            
        }        
    }, [objTipoSelezionato])

    const onSubmitMisura = async (value, event) => {        
    
        logger.debug("submit della misura di default", value);
        // alert(JSON.stringify(value, null, 2))
        // return;
        
        const nuovo = await creaTipiColli(value);

        const {altezza, larghezza, peso, lunghezza} = nuovo;
        logger.debug("creato nuovo tipo collo", nuovo, "aggiorno", drawerTipiColli.index);

        
        aggiornaPreferenze();
        svuotaEChiudi();
        aggiornaMisure(drawerTipiColli.index, nuovo);
    
        
        setDrawerTipiColli({
            open: false,
            index: -1
        })  
    }

    const svuotaEChiudi = () => {
        methodsMisura.reset();
        aggiornaPreferenze();
        setOpenDialogNuovaMisura(false);
    }

    return (
        <>
            <BSSDialogWithActions 
                closeHandler={e => svuotaEChiudi()} 
                title={__t("creamisurapredefper", [objTipoSelezionato.descrizione])}
                open={openDialogNuovaMisura} 
                actions={[
                    <Button key="button_salva" variant={"contained"} onClick={e => {                                            
                        methodsMisura.handleSubmit(onSubmitMisura, DefaultSubmitErrorHandler)()
                    }} style={{fontWeight: "bolder"}} color="primary" > 
                        <Save /> {__t("salva")}
                    </Button>,
                    <Button key="button_chiudi" variant={"contained"} onClick={e => {
                        svuotaEChiudi()
                    }} style={{fontWeight: "bolder"}} color="error" >
                        <Undo /> {__t("chiudi")}
                    </Button>
                ]}
            >
                <FormProvider {...methodsMisura} >
                    <BSSForm>  
                        <Box p={2}>
                            <FormGroup row>                                

                                <FormMisure {...{methods: methodsMisura, tipiSpedizione, readOnlyFields: ["tipoSpedizione"]}} />                                
                            </FormGroup>
                        </Box>
                        
                    </BSSForm>
                </FormProvider>
            </BSSDialogWithActions>
        </>
    )
}

export default DialogNuovaMisura;